import * as types from '../../actions/actiontypes';

import initialState from '../initialstate';

export function clientRequestAdvancedSearchOptionsReducer(
	state = initialState.clientRequestAdvancedSearchOptions,
	action
) {
	switch (action.type) {
		case types.SET_ADVANCED_SEARCH_OPTIONS:
			return {
				...action.data
			};
		case types.RESET_ADVANCED_SEARCH_OPTIONS:
			return initialState.clientRequestAdvancedSearchOptions;
		default:
			return state;
	}
}
